declare namespace $ {

	export class $yuf_video_play extends $yuf_check_icon2 {
		hint_checked( ): string
		hint_unchecked( ): string
		Icon_checked( ): $mol_icon_pause
		Icon_unchecked( ): $mol_icon_play
	}
	
}

//# sourceMappingURL=play.view.tree.d.ts.map